// extracted by mini-css-extract-plugin
export var filterIncDec = "_50-0";
export var leftBorder = "_50-1";
export var rightBorder = "_50-2";
export var stringInput = "_50-3";